const sourceColors = {
  Sendgrid: {
    backgroundColor: "#1a73e8",
    color: "#fff",
  },
  Apollo: {
    backgroundColor: "#f2f764",
    color: "#1f2937",
  },
  Other: {
    backgroundColor: "#6b7280",
    color: "#fff",
  },
};

const defaultSourceColors = {
  backgroundColor: "#e5e7eb",
  color: "#374151",
};

const sourceChipBase = {
  fontWeight: 600,
  fontSize: "0.75rem",
  height: "24px",
  lineHeight: "1",
  borderRadius: "4px",
};

export { sourceColors, defaultSourceColors, sourceChipBase };
